<template>
  <div class="row pad-to-15">
    <div class="col-md-12">
      <div class="buttonAdd row">
        <div class="pull-left">
          <div class="search-filter" style="display: flex; align-items: center; gap: 10px;">
            <input
              type="text"
              class="form-control"
              v-model="searchQuery"
              @keyup.enter="handleSearch"
              :placeholder="$t('customers.searchPlaceholder') || 'Caută după nume, telefon sau email...'"
              style="width: 300px;"
            />
            <button class="btn btn-icon btn-info" @click="handleSearch" :title="$t('general.search')">
              <i class="fa fa-search"></i>
            </button>
            <button v-if="searchQuery" class="btn btn-icon btn-default" @click="clearSearch" :title="$t('general.clear')">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div class="pull-right">
          <button class="btn btn-icon add" @click="$modal.show('groupModal')" :title="$t('customers.addGroup')">
            <img src="/static/img/icons/add.png">
            {{ $t('customers.addGroup') }}
          </button>
        </div>
      </div>
      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="group-container">
              <div v-if="!groupsData.length" class="no_group">
                <span>{{ $t('general.noData') || 'No data.' }}</span>
              </div>
              <div v-for="(item, idx) in groupsData" :key="item.id" class="group">
                <span @dblclick="handleEdit(idx, true)" :title="$t('general.edit')" style="display: flex; align-items: center; gap: 10px;">
                  <span v-show="!item.visibility">{{ item.name }}</span>
                  <span v-if="item.members_require_approval" class="approval-badge" :title="$t('customers.membersRequireApproval')">
                    <img src="/static/img/icons/icon-warning.png" style="width: 16px; height: 16px; opacity: 0.7;">
                  </span>
                  <span v-else class="no-approval-badge" :title="$t('customers.noApprovalRequired')">
                    <i class="fa fa-check-circle" style="color: #28a745; font-size: 16px;"></i>
                  </span>
                  <input type="text"
                        class="edit_input"
                        autofocus
                        ref="text_items"
                        :value="item.name"
                        v-show="item.visibility"
                        @keyup.enter="onEnter(idx)"
                        @keydown.esc="handleEdit(idx, false)"
                        style="flex: 1;"/>
                  <label v-show="item.visibility" class="checkbox-label" style="display: flex; align-items: center; cursor: pointer; font-size: 13px; margin-left: 10px; white-space: nowrap;">
                    <input type="checkbox" v-model="item.members_require_approval" style="margin-right: 5px;"/>
                    {{ $t('customers.membersRequireApproval') }}
                  </label>
                </span>
                <span>
                  <router-link class="btn btn-icon add" :to="{ path: '/groups/' + item.id}" :title="$t('general.add') + ' ' + $t('settingsPages.users').toLowerCase()">
                      <img src="/static/img/icons/add.png">
                      {{$t('general.add')}} {{ $t('settingsPages.users') }}
                  </router-link>
                  <a class="btn btn-danger btn-icon delete" @click="handleDelete(idx, item)">
                      <img src="/static/img/icons/icon-close.png">
                      {{$t('general.delete')}}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vmodal name="groupModal" height="auto" width="900" class="groupModal">
        <div class="card">
            <div class="card-content">
                <div class="modal-header">
                    <p>{{ $t('customers.addGroup') }}</p>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                      <label for="group_name">{{ $t('marketingOffers.title') }}</label>
                      <input
                        type="text"
                        @keyup.enter="validate"
                        class="form-control"
                        id="title"
                        name="title"
                        v-validate="modelValidations.title"
                        v-model="group.title"
                      />
                    </div>
                    <small class="text-danger" v-if="errors.has('title')">
                      {{ getError('title') }}
                    </small>
                    <div class="form-group" style="margin-top: 15px;">
                      <label class="checkbox-label" style="display: flex; align-items: center; cursor: pointer; font-weight: normal;">
                        <input
                          type="checkbox"
                          v-model="group.members_require_approval"
                          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer;"
                        />
                        {{ $t('customers.membersRequireApproval') }}
                      </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="button-group">
                        <button @click="validate" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
      </vmodal>
    </div>
</template>
<script>
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  export default{
    computed: {
    },
    created: function () {
      this.getData()
    },
    data () {
      return {
        groupsData: [],
        modelValidations: {
          title: {
            required: true
          }
        },
        loading: true,
        searchQuery: '',
        group: {
          title: '',
          members_require_approval: false
        }
      }
    },
    mounted () {
    },
    methods: {
      handleSearch () {
        this.getData()
      },
      clearSearch () {
        this.searchQuery = ''
        this.getData()
      },
      handleEdit (idx, focus) {
        this.groupsData[idx].visibility = !this.groupsData[idx].visibility
        if (focus) {
          this.$nextTick(() => this.$refs.text_items[idx].focus())
        }
      },
      onEnter (idx) {
        let val = this.$refs.text_items[idx].value
        this.groupsData[idx].name = val
        this.groupsData[idx].visibility = !this.groupsData[idx].visibility
        let id = this.groupsData[idx].id
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          name: val,
          members_require_approval: this.groupsData[idx].members_require_approval ? 1 : 0
        }
        this.apiRequest('customersgroup/' + id, 'PUT', data, (response) => {
          if (response.status) {
            this.group.title = ''
            this.group.members_require_approval = false
            this.$modal.hide('groupModal')
            this.getData()
            swal(
              this.$t('general.success') + '!',
              this.$t('customers.updateGroup'),
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.errors.clear()
            this.saveGroup()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0])
          } else {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      getData () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (this.searchQuery.trim()) {
          data.search = this.searchQuery.trim()
        }

        this.loading = true
        this.apiRequest('/customersgroup', 'GET', data, (response) => {
          if (response.status === true) {
            this.groupsData = response.data
            this.$nextTick(function () {
              this.loading = false
            })
          } else {
            this.loading = false
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      saveGroup () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          name: this.group.title,
          members_require_approval: this.group.members_require_approval ? 1 : 0
        }
        this.apiRequest('customersgroup', 'POST', data, (response) => {
          if (response.status) {
            this.group.title = ''
            this.group.members_require_approval = false
            this.$modal.hide('groupModal')
            this.getData()
            swal(
              this.$t('general.success') + '!',
              this.$t('customers.saveGroup'),
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      handleDelete (index, item) {
        swal({
          text: this.$t('marketingCampaigns.areYouSureDelete') + ` '${item.name}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/customersgroup/' + item.id, 'DELETE', data, (response) => {
              if (response.status === true) {
                swal(
                  '',
                  this.$t('customers.deleteGroup'),
                  'success'
                )
                this.groupsData.splice(index, 1)
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
        })
      }
    }
  }
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .header {
    padding-left: 15px;
  }
  .content-groups {
    margin: 10px 15px;
  }
  .group, .no_group {
    background: #ffffffbf;
    margin-top: 10px;
    padding: 12px 30px;
    font-size: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 11px;
  }
  .no_group {
    border: none;
  }
  .edit_input {
    border: none !important;
    border-bottom: 1px solid #ccc !important;
  }
  .groupModal .vm--modal{
      background-color: #F4F6FF !important;
      border-radius: 10px !important;
  }
  .approval-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff3cd;
    border-radius: 50%;
    padding: 3px;
  }
  .no-approval-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #d4edda;
    border-radius: 50%;
    padding: 3px;
  }
  .groupModal .vm--modal .card {
        border: none;
        background-color: #F4F6FF;
        margin-bottom: 0px;
        border-radius: 0px;
  }
  .search-filter input {
    border-radius: 6px;
    border: 1px solid #ddd;
    padding: 8px 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/Groups/Groups.vue